export default "__VITE_ASSET__d02e15dd__"